"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffPaymentRequestModel = instanceOfLiffPaymentRequestModel;
exports.LiffPaymentRequestModelFromJSON = LiffPaymentRequestModelFromJSON;
exports.LiffPaymentRequestModelFromJSONTyped = LiffPaymentRequestModelFromJSONTyped;
exports.LiffPaymentRequestModelToJSON = LiffPaymentRequestModelToJSON;
exports.LiffPaymentRequestModelToJSONTyped = LiffPaymentRequestModelToJSONTyped;
/**
 * Check if a given object implements the LiffPaymentRequestModel interface.
 */
function instanceOfLiffPaymentRequestModel(value) {
    return true;
}
function LiffPaymentRequestModelFromJSON(json) {
    return LiffPaymentRequestModelFromJSONTyped(json, false);
}
function LiffPaymentRequestModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderNo': json['orderNo'] == null ? undefined : json['orderNo'],
        'email': json['email'] == null ? undefined : json['email'],
        'returnURL': json['returnURL'] == null ? undefined : json['returnURL'],
        'notifyURL': json['notifyURL'] == null ? undefined : json['notifyURL'],
        'clientBackURL': json['clientBackURL'] == null ? undefined : json['clientBackURL'],
    };
}
function LiffPaymentRequestModelToJSON(json) {
    return LiffPaymentRequestModelToJSONTyped(json, false);
}
function LiffPaymentRequestModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderNo': value['orderNo'],
        'email': value['email'],
        'returnURL': value['returnURL'],
        'notifyURL': value['notifyURL'],
        'clientBackURL': value['clientBackURL'],
    };
}
